const mixin = {
  data() {
    return {
      filter: {
        page_num: 1,
        page_size: 10
      },
      totalPage: 1,
      pageSizeOption: [10, 20, 50, 100],
      totalItems: 0
    }
  },
  methods: {
    reset (o) {
    },
    search() {

    },
    // 页码跳转
    handleCurrentChange (val) {
      this.filter.page_num = val
      this.search()
    },
    // pagesize调整
    handleSizeChange (pageSize) {
      this.filter.page_size = pageSize
      this.search()
    },
  },
  mounted() {

  }
}

export default mixin
